export default __webpack_public_path__ + "static/media/DragonsSpine.16a4caf1.jpg";